/**
 * @generated SignedSource<<35b413af3dafe7077a49159a9a09eded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDataviz_visualization",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsPerPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableListViewOnFirstPage",
          "storageKey": null
        }
      ],
      "type": "ContributionsDataviz",
      "abstractKey": null
    }
  ],
  "type": "ParticipativeModuleVisualization",
  "abstractKey": "__isParticipativeModuleVisualization"
};

node.hash = "cdaab1c4fbc530c72c3b1c9f59f87c1d";

module.exports = node;
